
		export default{
			$newFashion:true,
		}